export default __webpack_public_path__ + "static/media/STARS.45da843a.svg";